module.exports = __webpack_public_path__ + "img/看板互联.39441fd1.gif";